var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M23.912 21.23a.49.49 0 0 1 .02.51.51.51 0 0 1-.44.26h-15a.51.51 0 0 1-.42-.27.49.49 0 0 1 0-.51l7.5-12a.51.51 0 0 1 .84 0l7.5 12.01zM9.392 21h13.2l-6.6-10.57L9.392 21zm6.1-6.51a.5.5 0 1 1 1 0v3a.5.5 0 0 1-1 0v-3zm.5 4.01a.5.5 0 1 1-.49.5.49.49 0 0 1 .49-.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.d544d41a2a994eacfaaae17d8774291a.svg";
export { ForwardRef as ReactComponent };